module.exports = __webpack_public_path__ + "static/media/soundexchange.8514a6d6.svg";